


























import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { AppModule } from "@/store/modules/app"
import { Session, Product } from '@/rest/models'
import { UtilApi, Configuration } from '@/rest'

@Component({
    name: 'tag-commander'
})
export default class TagCommander extends Vue {

    @Prop() private titleKey!: string
    @Prop() private template!: string

    private sessionLoaded = false
    private reloading = false
    private workEnvironment = ""
    private commandersActScript = ""
    private product: Product | null = null
    
    get session(){
        return AppModule.session
    }

    get locale(){
        if(AppModule.session && AppModule.session.locale){
            return AppModule.session.locale.toUpperCase()
        }
        return ""
    }

    get currency() {
        if(this.product && this.product.price) {
            return this.product.price.currency
        }
        return ""
    }

    get productId(){
        return AppModule.productID
    }

    get productEntry() {
        let result = ""
        result += 'product_id: "' + this.productId + '",'
        if(this.product) {
            result += 'product_name: "' + this.product.name + '",'
            if(this.product.price) {
                result += 'product_unitprice: "' + this.product.price.price + '",'
                result += 'product_discount: "",'
            }
            result += 'product_url: "' + this.product.url + '",'
            result += 'product_url_img: "' + this.product.imageUrl + '",'
            if(this.product.categories) {
                for(let i = 1; i <= this.product.categories.length; i++) {
                    result += 'product_cat' + i + '_name: "' + this.product.categories[i-1] + '",'
                }
            }
            result += 'product_qty: "1",'
        }
        return result
    }

    loadProduct() {
        if(AppModule.session && AppModule.session.products) {
            for (let i = 0; i < AppModule.session.products.length; i++){
                if (AppModule.session.products[i].itemId === AppModule.productID){
                    this.product = AppModule.session.products[i]
                    break
                }
            }
        }
        return
    }

    getWorkEnvironment() {
        let self = this
        let utilApi = new UtilApi(
            new Configuration({ basePath: '/rest'})
        )
        utilApi.getWorkEnvironment().then(
            (value) => {
                self.workEnvironment = value
                self.commandersActScript = (value != 'prod')? '//cdn.tagcommander.com/3973/uat/tc_myravensburger_22.js' : '//cdn.tagcommander.com/3973/tc_myravensburger_22.js'
            },
            (reason) => {
                window.console.log(reason)
            });
    }

    @Watch('sessionLoaded')
    sessionLoadedChanged(newSessionLoaded: boolean) {
        if(newSessionLoaded) {
            this.loadProduct()
        }
    }
    
    @Watch('session')
    sessionChanged(newSession: Session) {
        this.sessionLoaded = true
    }

    mounted() {
        if(this.session && this.session.sessionId){
            this.sessionLoaded = true
        }
        this.getWorkEnvironment()
    }

    reload() {
        this.reloading = true
        this.product = null
        if(this.sessionLoaded) {
            this.loadProduct()
            this.updateTcVars()
        }
        this.reloading = false
    }

    updateTcVars() {
        if((window as any).tc_vars && (window as any).tc_vars['product_array']) {
            type NewProduct = Record<string, string>
            if(this.product) {
                let newProduct: NewProduct = {
                    'product_id': this.productId, 
                    'product_name': this.product.name!, 
                    'product_url': this.product.url!, 
                    'product_url_img': this.product.imageUrl!, 
                    'product_qty': "1"
                }
                if(this.product.price) {
                    newProduct.product_unitprice = ""+this.product.price!.price
                    newProduct.product_discount = ""
                }
                if(this.product.categories) {
                    for(let i = 1; i <= this.product.categories.length; i++) {
                        newProduct['product_cat' + i + '_name'] = this.product.categories[i-1]
                    }
                }
                (window as any).tc_vars['product_array'][0] = newProduct
            }else {
                (window as any).tc_vars['product_array'][0] = {}
            }
        }
    }
}
